import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-slider',
  templateUrl: './custom-slider.component.html',
  styleUrls: ['./custom-slider.component.scss']
})
export class CustomSliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  sliderValue: number = 15;

  updateSlider(event: Event) {
    this.sliderValue = (event.target as HTMLInputElement).valueAsNumber;
  }
}
